import UAParser from 'ua-parser-js';

const UA = new UAParser();
const browser = UA.getBrowser();
const device = UA.getDevice();
const os = UA.getOS();
const isMobile = device.type === 'mobile';
const isIE = browser.name ? ['Internet Explorer', 'IE'].includes(browser.name) : false;
const isSafari = browser.name ? ['Safari', 'Mobile Safari'].includes(browser.name) : false;
const isFirefox = browser.name ? ['Firefox'].includes(browser.name) : false;
const isAndroid = os.name ? os.name.includes('Android') : false;

export { browser, device, isAndroid, isFirefox, isIE, isMobile, isSafari, os };
